import { RouteConfig } from 'vue-router';

import { contestListRoute } from './configRoute/contest.route';
import { eventsRoute } from './configRoute/events.route';
import { mailTemplateContainerRoute } from './configRoute/mailTemplateContainer.route';
import { moduleListRoute } from './configRoute/modules.route';
import { profileContainerRoute } from './configRoute/profileContainer.route';
import { roleContainerRoute } from './configRoute/roleContainer.route';
import { settingContainerRoute } from './configRoute/settingContainer.route';
import { stageContainerRoute } from './configRoute/stageContainer';
import { structureRoute } from './configRoute/structure.route';
import { templateRoute } from './configRoute/template.route';
import { viewContainerRoute } from './configRoute/viewContainer.route';
import { procedureCopyRoute } from './procedureRoute/copy.route';
import { schemaListRoute } from './schemas.route';

export const configRoute: RouteConfig = {
  path: 'config',
  name: 'config',
  component: () => import(/* webpackChunkName: "Config" */ '@/views/mainRoute/config/Config.vue'),
  meta: {
    breadcrumb: { title: 'Konfiguracja' },
    menu: {
      title: 'Konfiguracja',
      icon: 'fa-cog',
      permissions: [
        'EVENT.LIST',
        'MAIL_TEMPLATE.UPDATE',
        'MODULE.LIST',
        'USER.LIST',
        'ROLE.LIST',
        'SCHEMA.UPDATE',
        'STAGE.LIST',
        'STRUCTURE_NODE.UPDATE',
        'TEMPLATE.UPDATE',
        'VIEW.UPDATE',
        'SETTING.LIST',
        'CONTEST.UPDATE'
      ],
      permissionJoin: 'OR'
    }
  },
  children: [
    eventsRoute,
    mailTemplateContainerRoute,
    moduleListRoute,
    profileContainerRoute,
    roleContainerRoute,
    schemaListRoute,
    settingContainerRoute,
    stageContainerRoute,
    structureRoute,
    templateRoute,
    viewContainerRoute,
    procedureCopyRoute,
    contestListRoute
  ]
};
